// import React, { useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import "./inspectionConfiguration.css";

// const InspectionConfig = () => {
//   const [selectedPlan, setSelectedPlan] = useState("Basic");
//   const dispatch = useDispatch();
//   const { selectedItems, selectedMode, selectedCount } = useSelector(
//     (state) => state.inspectionConfigStore
//   );
//   console.log("108",selectedItems,selectedMode,selectedCount);
  
//   const inspectionFeatures = [
//     "Photo Mode",
//     "Video Mode",
//     "Hybrid Mode",
//     "8 sides of the car",
//     "Chassis No",
//     "Odometer",
//     "Windshield (interior & exterior)",
//     "Registration number",
//     "RC (Registration Certificate)",
//     "Selfie with the car",
//     "Engine video (optional)",
//     "360-degree video of the car",
//     "Tyre number identification",
//     // "Option to add additional images in the configuration",
//   ];

//   const planConfig = {
//     Basic: [true, false, false, true, true, true, true, true, true, true, true, false, false, false],
//     Standard: [true, true, true, true, true, true, true, true, true, true, true, true, false, false],
//     Premium: [true, true, true, true, true, true, true, true, true, true, true, true, true, true],
//   };

//   return (
//     <div className="inspection-container">
//       <h2>Inspection Configuration</h2>

//       <table className="inspection-table">
//         <thead>
//           <tr>
//             <th className="feature-column">Feature</th>
//             <th 
//               className={`plan-header ${selectedPlan === "Basic" ? "selected-plan" : ""}`} 
//               onClick={() => setSelectedPlan("Basic")}
//             >
//               Basic
//             </th>
//             <th 
//               className={`plan-header ${selectedPlan === "Standard" ? "selected-plan" : ""}`} 
//               onClick={() => setSelectedPlan("Standard")}
//             >
//               Standard
//             </th>
//             <th 
//               className={`plan-header ${selectedPlan === "Premium" ? "selected-plan" : ""}`} 
//               onClick={() => setSelectedPlan("Premium")}
//             >
//               Premium
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {inspectionFeatures.map((feature, index) => (
//             <tr key={feature}>
//               <td className="feature-cell">{feature}</td>
//               <td className={selectedPlan === "Basic" ? "highlight-cell" : ""}>
//                 {planConfig.Basic[index] ? "✔" : "X"}
//               </td>
//               <td className={selectedPlan === "Standard" ? "highlight-cell" : ""}>
//                 {planConfig.Standard[index] ? "✔" : "X"}
//               </td>
//               <td className={selectedPlan === "Premium" ? "highlight-cell" : ""}>
//                 {planConfig.Premium[index] ? "✔" : "X"}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default InspectionConfig;


import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { inspectionConfigActions } from '../../Store/onboard/inspectionConfigSlice';
import "./inspectionConfiguration.css";

const InspectionConfig = () => {
  const dispatch = useDispatch();
  
  const { selectedItems, selectedMode, selectedCount, currentPlan } = useSelector(
    (state) => state.inspectionConfigStore
  );
  
  console.log("Current config:", selectedItems, selectedMode, selectedCount, currentPlan);
  
  const inspectionFeatures = [
    "Photo Mode",
    "Video Mode",
    "Hybrid Mode",
    "8 sides of the car",
    "Chassis No",
    "Odometer",
    "Windshield (interior & exterior)",
    "Registration number",
    "RC (Registration Certificate)",
    "Selfie with the car",
    "Engine video (optional)",
    "360-degree video of the car",
    "Tyre number identification",
    // "Option to add additional images in the configuration",
  ];

  const planConfig = {
    Basic: [true, false, false, true, true, true, true, true, true, true, true, false, false, false],
    Standard: [true, true, false, true, true, true, true, true, true, true, true, true, false, false],
    Premium: [true, true, true, true, true, true, true, true, true, true, true, true, true, true],
  };

  // Handle plan selection with appropriate item and mode updates
  const handlePlanSelection = (plan) => {
    dispatch(inspectionConfigActions.setPlan(plan));
  };

  return (
    <div className="inspection-container">
      <h2>Inspection Configuration</h2>
      
      <table className="inspection-table">
        <thead>
          <tr>
            <th className="feature-column">Feature</th>
            <th
              className={`plan-header ${currentPlan === "Basic" ? "selected-plan" : ""}`}
              onClick={() => handlePlanSelection("Basic")}
            >
              Basic
            </th>
            <th
              className={`plan-header ${currentPlan === "Standard" ? "selected-plan" : ""}`}
              onClick={() => handlePlanSelection("Standard")}
            >
              Standard
            </th>
            <th
              className={`plan-header ${currentPlan === "Premium" ? "selected-plan" : ""}`}
              onClick={() => handlePlanSelection("Premium")}
            >
              Premium
            </th>
          </tr>
        </thead>
        <tbody>
          {inspectionFeatures.map((feature, index) => (
            <tr key={feature}>
              <td className="feature-cell">{feature}</td>
              <td className={currentPlan === "Basic" ? "highlight-cell" : ""}>
                {planConfig.Basic[index] ? "✔" : "✗"}
              </td>
              <td className={currentPlan === "Standard" ? "highlight-cell" : ""}>
                {planConfig.Standard[index] ? "✔" : "✗"}
              </td>
              <td className={currentPlan === "Premium" ? "highlight-cell" : ""}>
                {planConfig.Premium[index] ? "✔" : "✗"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InspectionConfig;
